define('lib/Podio.UI.SearchInput',['require','lib/Podio.Event.UI'],function(require) {

  var eventUI = require('lib/Podio.Event.UI');

  function onSearchFormSubmit(elmTarget, e) {
    var query;
    query = elmTarget.find("input[name='query']").val();
    if (query.length) {
      window.location = elmTarget.attr('action') + '#/query/' + encodeURIComponent(query);
    }
  }

  eventUI.bind('submit', '.nav-box .search .searchform', onSearchFormSubmit);
  eventUI.bind('submit', '.nav-box .podio-search .searchform', onSearchFormSubmit);

});

